import axios from "axios";
import { pdf } from '@react-pdf/renderer';
import { createElement } from 'react';
import DonationRequestWorksheet from '../components/forms/DonationRequestWorksheet';

const API_URL = import.meta.env.VITE_API_URL;

// Create axios instance with default config
const api = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json'
    }
});

// Helper function to convert file to base64
const fileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      // Remove the data URL prefix (e.g., "data:image/jpeg;base64,")
      const base64String = reader.result.split(',')[1];
      resolve(base64String);
    };
    reader.onerror = (error) => reject(error);
  });
};

// Function to prepare vehicle images
const prepareVehicleImages = async (images) => {
  const preparedImages = [];
  for (const image of images) {
    const base64Content = await fileToBase64(image.file);
    preparedImages.push({
      fileName: image.file.name,
      fileType: image.file.type,
      fileSize: image.file.size,
      base64Content
    });
  }
  return preparedImages;
};

// Function to submit donation form
export const submitDonationForm = async (formData) => {
  try {
    // Convert boolean string values to actual booleans
    const vehicleInfo = {
      ...formData.vehicleInfo,
      titleAvailable: formData.vehicleInfo.titleAvailable === 'yes',
      isRunning: formData.vehicleInfo.isRunning === 'yes',
      canDrive20Miles: formData.vehicleInfo.canDrive20Miles === 'yes',
      images: await prepareVehicleImages(formData.vehicleInfo.images || [])
    };

    // Convert isCarAtAddress to boolean
    const pickup = {
      ...formData.pickup,
      isCarAtAddress: formData.pickup.isCarAtAddress === 'yes'
    };

    // Prepare the final form data
    const submissionData = {
      formData: {
        vehicleInfo,
        pickup,
        contact: formData.contact
      }
    };

    const response = await api.post('/donation-form-submit.php', submissionData);

    return response.data;
  } catch (error) {
    console.error('Error submitting donation form:', error);
    throw error;
  }
};

// Function to send donation worksheet PDF
export const sendDonationWorksheetPDF = async (donationData) => {
  try {
    // Generate PDF blob
    const element = createElement(DonationRequestWorksheet, { donation: donationData });
    const pdfDoc = await pdf(element);
    const pdfBlob = await pdfDoc.toBlob();
    const base64PDF = await fileToBase64(new File([pdfBlob], 'donation-worksheet.pdf', { type: 'application/pdf' }));

    const submissionData = {
      email: donationData.contact.email,
      name: `${donationData.contact.firstName} ${donationData.contact.lastName}`,
      year: donationData.vehicleInfo.year,
      make: donationData.vehicleInfo.make,
      model: donationData.vehicleInfo.model,
      pdf: base64PDF
    };

    const response = await api.post('/donation-form-submit-email.php', submissionData);
    return response.data;
  } catch (error) {
    console.error('Error sending donation worksheet PDF:', error);
    throw error;
  }
};

export const contactUsEmail = async (firstName, lastName, email, phone, message) => {
  try{
    const response = await api.post('/contact-us-email.php', {
      first_name: firstName,
      last_name: lastName,
      email,
      phone,
      message
    });
  
    
    return response.data;
  }catch (error) {
    console.error('Error sending contact us email:', error);
    throw error;
  }
};